"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var omit = require("lodash.omit");
var Color = require("color");
var react_1 = require("react");
var components_1 = require("components");
var styles_1 = require("styles");
var componentStyle = {
    base: {
        width: 56,
        height: 56,
        boxShadow: '0 6px 16px -5px rgba(0, 0, 0, 0.4)',
        ':hover': {
            boxShadow: '0 10px 26px -7px rgba(0, 0, 0, 0.4)',
        },
    },
};
var setBackgroundColor = function (bgColor) { return ({
    backgroundColor: bgColor,
    ':active': {
        backgroundColor: Color(bgColor).lighten(0.2).rgb().string(),
    },
}); };
var getStyle = function (style, props) { return ([
    style.base,
    setBackgroundColor(props.color),
    props.style,
]); };
var FAB = (function (_super) {
    __extends(FAB, _super);
    function FAB() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FAB.prototype.render = function () {
        var _a = omit(this.props, ['style']), style = _a.style, otherProps = __rest(_a, ["style"]);
        return (React.createElement(components_1.IconButton, __assign({ style: getStyle(componentStyle, this.props) }, otherProps)));
    };
    FAB.defaultProps = {
        color: Color(styles_1.BackgroundColor.Red).darken(.1).rgb().string(),
        iconColor: styles_1.FontColor.White,
    };
    FAB = __decorate([
        Radium
    ], FAB);
    return FAB;
}(react_1.PureComponent));
exports.FAB = FAB;



//////////////////
// WEBPACK FOOTER
// ./src/components/FloatingActionButton/FAB.tsx
// module id = 294
// module chunks = 0